import React, { useContext, useEffect, useRef, useState } from 'react'
import MainNav from '../../Components/Navbar'
import axios from 'axios';
import { Col, Container, Row } from 'react-bootstrap';
import TabelaUsuarios from '../../Components/TabelaUsuarios';
import CadastroUsuarios from '../../Components/CadastroUsuarios';
import ToastManager from '../../Components/ToastManager';
import GlobalContext from '../../Components/GlobalContext';
import { child, get, getDatabase, ref } from 'firebase/database';

function Usuarios(props) {

    const [usuarios, setUsuarios] = useState([]);
    const { globalData, setGlobalData } = useContext(GlobalContext);

    useEffect(() => {
        refreshListaUsuarios()
    }, [])

    const db = getDatabase();

    const refreshListaUsuarios = () => {
        axios.get(`${globalData.apiHost}/users`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_BACKEND_SECRET
            }
        })
            .then(function (resp) {

                get(child(ref(db), '/roles')).then((snapshot) => {
                    let result = snapshot.val()

                    const keys = Object.keys(result)

                    let data = resp.data

                    if (result) {
                        for (let user in data) {
                            if (keys.includes(data[user].uid)) {
                                data[user]['perm'] = result[data[user].uid]
                            }
                        }
                        setUsuarios(data);
                    } else {
                        setUsuarios(resp.data)
                    }
                }).catch((error) => {
                    setUsuarios(resp.data)
                })

            }).catch((error) => console.log(error));
    }

    const toastManagerRef = useRef(null);

    const handleShowToast = (title, text, variant) => {
        if (toastManagerRef.current) {
            toastManagerRef.current.createToast(title, text, variant)
        }
    }

    return (
        <>
            <ToastManager ref={toastManagerRef} />
            <MainNav />
            <Container className='pt-3'>
                <Row className='d-flex justify-content-center'>
                    <Col md={8}>
                        <CadastroUsuarios handleShowToast={handleShowToast} refreshListaUsuarios={refreshListaUsuarios} />
                    </Col>
                </Row>
                <Row className='d-flex justify-content-center mt-3'>
                    <Col md={8}>
                        <TabelaUsuarios usuarios={usuarios} handleShowToast={handleShowToast} refreshListaUsuarios={refreshListaUsuarios} />
                    </Col>
                </Row>
            </Container>
        </>
    )
}


export default Usuarios